<template>
	<!-- 테이블 컨텐츠 -->
	<div>
		<div class="d_flex mb_20">
			<div class="back_btn" @click="$emit('showDealList')">
				<span class="LEFTARROW"></span>
				<h3 class="">{{ $t('rtr_activity-c2c.title3') }}</h3>
			</div>
		</div>

		<!--			<div class="title mb_20 mt_20 d_flex align_items_center"></div>-->
		<div class="table" v-if="dealDetailList.length > 0 && !isMobile">
			<!-- 테이블 컨텐츠 -->
			<div class="table_item" v-for="item in dealDetailList" :key="item.seq">
				<div class="list_item type02">
					<div class="list_num">{{ item._no }}</div>
					<div class="list_item_cont">
						<div class="top_cont">
							<div class="item_box">
								<div class="item">
									<p>{{ $t('rtr_activity-c2c.sold_asset') }}</p>
									<div class="asset_box mb_10">
										<span :class="[item.source_asset_codem, 'small']"></span>
										<p class="code mr_4">{{ item.source_asset_code }}</p>
										<p class="name">{{ item.source_asset_title }}</p>
									</div>
									<p class="fs_12 fc_gray2">
										{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
									</p>
								</div>
								<div class="item">
									<p>{{ $t('rtr_activity-c2c.registered_quantity') }}</p>
									<p>{{ item.source_amount }}</p>
								</div>
								<div class="item tal">
									<p>{{ $t('rtr_activity-c2c.sold_price') }}</p>
									<p>
										1 <span class="fs_12">{{ item.source_asset_code }} = </span>
									</p>
									<p>
										{{ item.price }}
										<span class="fs_12">{{ item.target_asset_code }}</span>
									</p>
								</div>
								<div class="item">
									<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
									<div class="asset_box mb_10">
										<span :class="[item.target_asset_code, 'small']"></span>
										<p class="code mr_4">{{ item.target_asset_code }}</p>
										<p class="name">{{ item.target_asset_title }}</p>
									</div>
								</div>
							</div>
							<div class="status_area d_flex align_items_center">
								<div :class="'status ' + item.status">
									<span class="icon"></span>
									<span>{{ $t('c2c.' + item.status) }}</span>
								</div>
							</div>
						</div>
						<div class="bottom_cont">
							<div class="item">
								<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
								<p>{{ item.fee_amount }}</p>
							</div>
							<div class="item ma_0">
								<p>{{ $t('rtr_activity-c2c.charge_fee') }}</p>
								<p>{{ item.deal_fee_amount }}</p>
							</div>
						</div>
					</div>
				</div>

				<!-- 테이블 컨텐츠2 -->
				<div class="list_item2">
					<div class="btn_area">
						<button class="button_primary" @click="$emit('showDetail', item)">
							{{ $t('button.detail') }}
						</button>
						<template
							v-if="
								item.escrow_type === 'DEALER' || item.escrow_type === 'DISABLE'
							"
						>
							<button
								class="green"
								v-if="item.status === 'PENDING' || item.status === 'PAYED'"
								@click="privateApplicationHandler(item.seq, 'SET_CONFIRMED')"
							>
								{{ $t('button.decide') }}
							</button>
							<button
								class="button_bg_red"
								v-if="item.status === 'PENDING'"
								@click="privateApplicationHandler(item.seq, 'SET_REJECTED')"
							>
								{{ $t('button.reject') }}
							</button>
						</template>
						<template v-if="item.escrow_type === 'APPLICANT'">
							<button
								class="button_bg_blue"
								v-if="item.status === 'PENDING'"
								@click="privateApplicationHandler(item.seq, 'SET_PAYED')"
							>
								{{ $t('button.payment') }}
							</button>
							<button
								class="button_bg_red"
								v-if="item.status === 'PENDING' || item.status === 'PAYED'"
								@click="privateApplicationHandler(item.seq, 'SET_REJECTED')"
							>
								{{ $t('button.reject') }}
							</button>
						</template>
					</div>
				</div>
			</div>
			<pagination
				:totalCount="pageNavigation.total_count"
				:totalPage="pageNavigation.total_page"
				:curPage="pageNavigation.cur_page"
				:point="pageNavigation.point"
				:firstPage="pageNavigation.first_page"
				:lastPage="pageNavigation.last_page"
				@change="pageChangeHandler"
			></pagination>
		</div>
		<div class="table_mobile" v-if="dealDetailList.length > 0 && isMobile">
			<div
				class="table_item_mobile"
				v-for="item in dealDetailList"
				:key="item.seq"
			>
				<div class="list_item_mobile">
					<div class="cont">
						<div class="list_title_box">
							<div class="list_num">{{ item._no }}</div>
							<p class="fs_12 fc_gray2">
								{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
							</p>
						</div>
						<div class="list_info_box">
							<div class="item">
								<div class="status_area d_flex align_items_center">
									<div :class="'status ' + item.status">
										<span class="icon"></span>
										<span>{{ $t('c2c.' + item.status) }}</span>
									</div>
								</div>
							</div>
							<div class="item">
								<div>
									<p>{{ $t('rtr_activity-c2c.sold_asset') }}</p>
									<div class="asset_box">
										<span :class="[item.source_asset_codem, 'small']"></span>
										<p class="code mr_4 mb_0">{{ item.source_asset_code }}</p>
										<p class="name">{{ item.source_asset_title }}</p>
									</div>
								</div>
								<div>
									<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
									<div class="asset_box">
										<span :class="[item.target_asset_code, 'small']"></span>
										<p class="code mr_4">{{ item.target_asset_code }}</p>
										<p class="name">{{ item.target_asset_title }}</p>
									</div>
								</div>
							</div>

							<div class="item">
								<div>
									<p>{{ $t('rtr_activity-c2c.registered_quantity') }}</p>
									<p>{{ item.source_amount }}</p>
								</div>
							</div>
							<div class="item tal">
								<div>
									<p>{{ $t('rtr_activity-c2c.sold_price') }}</p>
									<p>
										1 <span class="fs_12">{{ item.source_asset_code }} = </span>
									</p>
									<p>
										{{ item.price }}
										<span class="fs_12">{{ item.target_asset_code }}</span>
									</p>
								</div>
							</div>
						</div>
						<div class="button_area">
							<button class="button_bg_blue" @click="$emit('showDetail', item)">
								{{ $t('button.detail') }}
							</button>
						</div>
						<div class="button_more_area">
							<div class="line"></div>
							<button @click="toggleMoreContent(item.seq)">
								<img
									:src="isItemOpen(item.seq) ? moreClose : more"
									alt="more"
									style="width: 24px; height: 24px"
								/>
							</button>
						</div>
					</div>
					<div class="more_cont" v-if="isItemOpen(item.seq)">
						<div class="list_info_box">
							<div class="item">
								<div>
									<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
									<p>{{ item.fee_amount }}</p>
								</div>
							</div>
							<div class="item ma_0">
								<div>
									<p>{{ $t('rtr_activity-c2c.charge_fee') }}</p>
									<p>{{ item.deal_fee_amount }}</p>
								</div>
							</div>
						</div>
						<div class="button_area">
							<template
								v-if="
									item.escrow_type === 'DEALER' ||
									item.escrow_type === 'DISABLE'
								"
							>
								<button
									class="green"
									v-if="item.status === 'PENDING' || item.status === 'PAYED'"
									@click="privateApplicationHandler(item.seq, 'SET_CONFIRMED')"
								>
									{{ $t('button.decide') }}
								</button>
								<button
									class="button_bg_red"
									v-if="item.status === 'PENDING'"
									@click="privateApplicationHandler(item.seq, 'SET_REJECTED')"
								>
									{{ $t('button.reject') }}
								</button>
							</template>
							<template v-if="item.escrow_type === 'APPLICANT'">
								<button
									class="button_bg_blue"
									v-if="item.status === 'PENDING'"
									@click="privateApplicationHandler(item.seq, 'SET_PAYED')"
								>
									{{ $t('button.payment') }}
								</button>
								<button
									class="button_bg_red"
									v-if="item.status === 'PENDING' || item.status === 'PAYED'"
									@click="privateApplicationHandler(item.seq, 'SET_REJECTED')"
								>
									{{ $t('button.reject') }}
								</button>
							</template>
						</div>
					</div>
				</div>
			</div>
			<pagination
				:totalCount="pageNavigation.total_count"
				:totalPage="pageNavigation.total_page"
				:curPage="pageNavigation.cur_page"
				:point="pageNavigation.point"
				:firstPage="pageNavigation.first_page"
				:lastPage="pageNavigation.last_page"
				@change="pageChangeHandler"
			></pagination>
		</div>
		<div v-if="dealDetailList.length === 0">
			<div class="list_none" v-if="!loading">
				<span class="ERRORGRAY"></span>
				<p>{{ $t('rtr_activity-c2c.empty2') }}</p>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="button_bg_blue" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button class="button_primary" @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="button_bg_blue" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import Pagination from '@/components/Pagination';
import ModalMessage from '@/components/Layout/ModalMessage';
import {
	confirmPrivateApplication,
	fetchPrivateApplications,
	payPrivateApplication,
	rejectPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';
import more from '@/assets/images/v2/icon/more.svg';
import moreClose from '@/assets/images/v2/icon/more-close.svg';
export default {
	name: 'SaleDetailList',
	emits: ['showDealList', 'showDetail'],
	props: {
		dealSeq: {
			type: Number,
		},
	},
	components: {
		Pagination,
		ModalMessage,
	},
	data() {
		return {
			dealDetailList: {},
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			patchSeq: null,
			patchType: '',
			loading: false,
			isMobile: false,
			openedItems: [],
			more,
			moreClose,
		};
	},
	created() {
		this.init();
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		init() {
			this.loadDealDetailList();
		},
		async loadDealDetailList() {
			this.loading = true;
			const params = {
				page: this.curPage,
				list_count: this.listCount,
				deal_seq: this.dealSeq,
			};
			const { data, page_navigation } = await fetchPrivateApplications(
				params,
			).catch(commonError);
			this.loading = false;
			this.dealDetailList = data;
			this.pageNavigation = page_navigation;
		},
		toggleMoreContent(itemSeq) {
			const index = this.openedItems.indexOf(itemSeq);
			if (index > -1) {
				this.openedItems.splice(index, 1);
			} else {
				this.openedItems.push(itemSeq);
			}
		},
		isItemOpen(itemSeq) {
			return this.openedItems.includes(itemSeq);
		},
		privateApplicationHandler(seq, type) {
			this.patchSeq = seq;
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_REJECTED':
					message = this.$t('modal.message.set_reject');
					break;
				case 'SET_PAYED':
					message = this.$t('modal.message.set_pay');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('modal.message.set_confirm');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message;
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_REJECTED':
					this.rejectPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		async rejectPrivateApplication() {
			await rejectPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_reject');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealDetailList();
				})
				.catch(commonError);
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadDealDetailList();
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
	},
};
</script>
<style scoped></style>
